var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5759 6.46277H10.5759V9.56277H13.6039V10.5628H10.5759V13.6628H9.5759V10.5628H6.4039V9.56277H9.5759V6.46277Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00391 10.0627C2.00391 5.65154 5.59271 2.06274 10.0039 2.06274C14.4151 2.06274 18.0039 5.65154 18.0039 10.0627C18.0039 14.4739 14.4151 18.0627 10.0039 18.0627C5.59271 18.0627 2.00391 14.4739 2.00391 10.0627ZM3.00391 10.0627C3.00391 13.9227 6.14391 17.0627 10.0039 17.0627C13.8635 17.0627 17.0039 13.9223 17.0039 10.0627C17.0039 6.20314 13.8639 3.06274 10.0039 3.06274C6.14391 3.06274 3.00391 6.20274 3.00391 10.0627Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.a12c89a3c3d89c1e61682aec1e61cccb.svg";
export { ForwardRef as ReactComponent };